var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$can('read-general-info', 'user'))?_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",attrs:{"to":{path: `/marketing/${_vm.row.hashid}/actions/${_vm.tab}`}}},[_c('i',{staticClass:"fa fa-eye"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }